
//V2 src/components/editBatchForm.js

// src/components/editBatchForm.js
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getBatchConsolidadoById, updateBatchConsolidado } from "../api";
import DatePicker from "react-datepicker";
import { es } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

const EditBatchForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const company = JSON.parse(localStorage.getItem("company"));
  const user = JSON.parse(localStorage.getItem("user"));

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Campos editables base
  const [idBatch, setIdBatch] = useState("");
  const [codMaq, setCodMaq] = useState("");
  const [idProd, setIdProd] = useState("");
  const [model, setModel] = useState("");

  const [idShift, setIdShift] = useState("");
  const [idOperator, setIdOperator] = useState("");

  const [cantPtOk, setCantPtOk] = useState(0);
  const [cantPtNc, setCantPtNc] = useState(0);

  const [dateBegin, setDateBegin] = useState(null);
  const [timeBegin, setTimeBegin] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);

  // Solo lectura (derivados) – si quieres mostrarlos en el formulario
  const [totalHr, setTotalHr] = useState(null);
  const [totalOper, setTotalOper] = useState(null);
  const [operStdXhr, setOperStdXhr] = useState(null);
  const [undXOper, setUndXOper] = useState(null);
  const [undStdXhr, setUndStdXhr] = useState(null);
  const [percentEff, setPercentEff] = useState(null);
  const [productEff, setProductEff] = useState(null);
  const [conforming, setConforming] = useState(null);

  // =========================
  // Helpers (ANTI -1 DÍA por TZ)
  // =========================

  // Para campos DATE (YYYY-MM-DD) -> Date local (sin drift por zona horaria)
  const parseDateOnly = (value) => {
    if (!value) return null;

    const s = String(value);
    const ymd = s.slice(0, 10); // "YYYY-MM-DD" incluso si viene "YYYY-MM-DDT00:00:00.000Z"
    const [y, m, d] = ymd.split("-").map(Number);

    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d); // Local, sin conversión UTC
  };

  // HH:mm:ss (o HH:mm) -> Date hoy con esa hora (para DatePicker showTimeSelectOnly)
  const hhmmssToDate = (t) => {
    if (!t) return null;
    const [h, m] = String(t).split(":");
    const d = new Date();
    d.setHours(Number(h) || 0, Number(m) || 0, 0, 0);
    return d;
  };

  const formatDate = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate()
        ).padStart(2, "0")}`
      : null;

  const formatTime = (d) =>
    d
      ? `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(
          2,
          "0"
        )}:00`
      : null;

  useEffect(() => {
    const load = async () => {
      try {
        if (!company?.id_c) {
          alert("Falta company");
          return navigate(-1);
        }
        if (!id) {
          alert("ID de batch no encontrado");
          return navigate(-1);
        }

        const { batch } = await getBatchConsolidadoById(company.id_c, Number(id));

        // Debug útil para producción (puedes borrarlo después)
        console.log("date_begin raw:", batch?.date_begin, typeof batch?.date_begin);

        setIdBatch(batch.id_batch || "");
        setCodMaq(batch.cod_maq || "");
        setIdProd(batch.id_prod || "");
        setModel(batch.model || "");
        setIdShift(batch.id_shift || "");
        setIdOperator(batch.id_operator || "");
        setCantPtOk(batch.cant_pt_ok ?? 0);
        setCantPtNc(batch.cant_pt_nc ?? 0);

        // ✅ FIX: NO usar new Date("YYYY-MM-DD") para DATE de MySQL (evita -1 día por TZ)
        setDateBegin(parseDateOnly(batch.date_begin));

        setTimeBegin(hhmmssToDate(batch.time_begin));
        setTimeEnd(hhmmssToDate(batch.time_end));

        setTotalHr(batch.total_hr_batch);
        setTotalOper(batch.total_oper_batch);
        setOperStdXhr(batch.oper_stdxhr);
        setUndXOper(batch.undxoper);
        setUndStdXhr(batch.und_stdxhr);
        setPercentEff(batch.percent_efficiency);
        setProductEff(batch.product_efficiency);
        setConforming(batch.conforming_prod);
      } catch (e) {
        console.error("❌ Error fetching batch:", e);
        alert(t("Error al cargar el lote"));
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [company?.id_c, id, navigate, t]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        id_batch: idBatch,
        id_user: user?.id_u ?? null,
        cod_maq: codMaq,
        id_prod: idProd,
        model,
        id_shift: idShift || null,
        id_operator: idOperator || null,
        cant_pt_ok: Number(cantPtOk) || 0,
        cant_pt_nc: Number(cantPtNc) || 0,

        // date_begin se envía como string YYYY-MM-DD (sin TZ)
        date_begin: formatDate(dateBegin),

        time_begin: formatTime(timeBegin),
        time_end: formatTime(timeEnd),
      };

      await updateBatchConsolidado(company.id_c, Number(id), payload);
      alert(t("Lote actualizado"));
      navigate(-1);
    } catch (e) {
      console.error("❌ Error updating batch:", e);
      alert(t("Ocurrió un error al actualizar el lote."));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="box1">{t("Cargando...")}</p>;

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSave}>
          <table className="form1">
            <tbody>
              <tr>
                <td>
                  <label>{t("batchList12") || "ID Lote"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={idBatch}
                    onChange={(e) => setIdBatch(e.target.value)}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList2") || "Código de Máquina"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={codMaq}
                    onChange={(e) => setCodMaq(e.target.value)}
                    required
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList3") || "Producto"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={idProd}
                    onChange={(e) => setIdProd(e.target.value)}
                    required
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList27") || "Modelo"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("shifts1") || "Turno"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={idShift}
                    onChange={(e) => setIdShift(e.target.value)}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("operator1") || "Operador"}</label>
                </td>
                <td>
                  <input
                    className="input1"
                    value={idOperator}
                    onChange={(e) => setIdOperator(e.target.value)}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>PT OK</label>
                </td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={cantPtOk}
                    onChange={(e) => setCantPtOk(e.target.value)}
                    min="0"
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>PT NC</label>
                </td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={cantPtNc}
                    onChange={(e) => setCantPtNc(e.target.value)}
                    min="0"
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList7") || "Fecha"}</label>
                </td>
                <td>
                  <DatePicker
                    selected={dateBegin}
                    onChange={setDateBegin}
                    dateFormat="yyyy-MM-dd"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList8") || "Hora Inicio"}</label>
                </td>
                <td>
                  <DatePicker
                    selected={timeBegin}
                    onChange={setTimeBegin}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label>{t("batchList10") || "Hora Fin"}</label>
                </td>
                <td>
                  <DatePicker
                    selected={timeEnd}
                    onChange={setTimeEnd}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>

              {/* Si quieres mostrar derivados (solo lectura) */}
              <tr>
                <td colSpan={2}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>Total horas</td>
                <td>
                  <input className="input1" value={totalHr ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>Operaciones</td>
                <td>
                  <input className="input1" value={totalOper ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>Oper std x hr</td>
                <td>
                  <input className="input1" value={operStdXhr ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>Und x oper</td>
                <td>
                  <input className="input1" value={undXOper ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>Und std x hr</td>
                <td>
                  <input className="input1" value={undStdXhr ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>% Efic. Ops</td>
                <td>
                  <input className="input1" value={percentEff ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>% Efic. Prod</td>
                <td>
                  <input className="input1" value={productEff ?? "-"} disabled />
                </td>
              </tr>
              <tr>
                <td>% Conformidad</td>
                <td>
                  <input className="input1" value={conforming ?? "-"} disabled />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7" disabled={saving}>
            {saving ? t("Guardando...") : t("Guardar")}
          </button>

          <button type="button" className="button7" onClick={() => navigate(-1)}>
            {t("Cancelar")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditBatchForm;


{/*}

// V1 src/components/editBatchForm.js
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getBatchConsolidadoById, updateBatchConsolidado } from "../api";
import DatePicker from "react-datepicker";
import { es } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

const EditBatchForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const company = JSON.parse(localStorage.getItem("company"));
  const user = JSON.parse(localStorage.getItem("user"));

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Campos editables base
  const [idBatch, setIdBatch] = useState("");
  const [codMaq, setCodMaq] = useState("");
  const [idProd, setIdProd] = useState("");
  const [model, setModel] = useState("");

  const [idShift, setIdShift] = useState("");
  const [idOperator, setIdOperator] = useState("");

  const [cantPtOk, setCantPtOk] = useState(0);
  const [cantPtNc, setCantPtNc] = useState(0);

  const [dateBegin, setDateBegin] = useState(null);
  const [timeBegin, setTimeBegin] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);

  // Solo lectura (derivados) – si quieres mostrarlos en el formulario
  const [totalHr, setTotalHr] = useState(null);
  const [totalOper, setTotalOper] = useState(null);
  const [operStdXhr, setOperStdXhr] = useState(null);
  const [undXOper, setUndXOper] = useState(null);
  const [undStdXhr, setUndStdXhr] = useState(null);
  const [percentEff, setPercentEff] = useState(null);
  const [productEff, setProductEff] = useState(null);
  const [conforming, setConforming] = useState(null);

  const hhmmssToDate = (t) => {
    if (!t) return null;
    const [h, m] = String(t).split(":");
    const d = new Date();
    d.setHours(Number(h)||0, Number(m)||0, 0, 0);
    return d;
  };
  const formatDate = (d) => d ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}` : null;
  const formatTime = (d) => d ? `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}:00` : null;

  useEffect(() => {
    const load = async () => {
      try {
        if (!company?.id_c) { alert("Falta company"); return navigate(-1); }
        if (!id) { alert("ID de batch no encontrado"); return navigate(-1); }

        const { batch } = await getBatchConsolidadoById(company.id_c, Number(id));

        setIdBatch(batch.id_batch || "");
        setCodMaq(batch.cod_maq || "");
        setIdProd(batch.id_prod || "");
        setModel(batch.model || "");
        setIdShift(batch.id_shift || "");
        setIdOperator(batch.id_operator || "");
        setCantPtOk(batch.cant_pt_ok ?? 0);
        setCantPtNc(batch.cant_pt_nc ?? 0);

        setDateBegin(batch.date_begin ? new Date(batch.date_begin) : null);
        setTimeBegin(hhmmssToDate(batch.time_begin));
        setTimeEnd(hhmmssToDate(batch.time_end));

        setTotalHr(batch.total_hr_batch);
        setTotalOper(batch.total_oper_batch);
        setOperStdXhr(batch.oper_stdxhr);
        setUndXOper(batch.undxoper);
        setUndStdXhr(batch.und_stdxhr);
        setPercentEff(batch.percent_efficiency);
        setProductEff(batch.product_efficiency);
        setConforming(batch.conforming_prod);
      } catch (e) {
        console.error("❌ Error fetching batch:", e);
        alert(t("Error al cargar el lote"));
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [company?.id_c, id, navigate, t]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        id_batch: idBatch,
        id_user: user?.id_u ?? null,
        cod_maq: codMaq,
        id_prod: idProd,
        model,
        id_shift: idShift || null,
        id_operator: idOperator || null,
        cant_pt_ok: Number(cantPtOk) || 0,
        cant_pt_nc: Number(cantPtNc) || 0,
        date_begin: formatDate(dateBegin),
        time_begin: formatTime(timeBegin),
        time_end: formatTime(timeEnd),
      };
      await updateBatchConsolidado(company.id_c, Number(id), payload);
      alert(t("Lote actualizado"));
      navigate(-1);
    } catch (e) {
      console.error("❌ Error updating batch:", e);
      alert(t("Ocurrió un error al actualizar el lote."));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="box1">{t("Cargando...")}</p>;

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSave}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label>{t("batchList12") || "ID Lote"}</label></td>
                <td><input className="input1" value={idBatch} onChange={(e)=>setIdBatch(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("batchList2") || "Código de Máquina"}</label></td>
                <td><input className="input1" value={codMaq} onChange={(e)=>setCodMaq(e.target.value)} required/></td>
              </tr>
              <tr>
                <td><label>{t("batchList3") || "Producto"}</label></td>
                <td><input className="input1" value={idProd} onChange={(e)=>setIdProd(e.target.value)} required/></td>
              </tr>
              <tr>
                <td><label>{t("batchList27") || "Modelo"}</label></td>
                <td><input className="input1" value={model} onChange={(e)=>setModel(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("shifts1") || "Turno"}</label></td>
                <td><input className="input1" value={idShift} onChange={(e)=>setIdShift(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("operator1") || "Operador"}</label></td>
                <td><input className="input1" value={idOperator} onChange={(e)=>setIdOperator(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>PT OK</label></td>
                <td><input className="input1" type="number" value={cantPtOk} onChange={(e)=>setCantPtOk(e.target.value)} min="0" /></td>
              </tr>
              <tr>
                <td><label>PT NC</label></td>
                <td><input className="input1" type="number" value={cantPtNc} onChange={(e)=>setCantPtNc(e.target.value)} min="0" /></td>
              </tr>
              <tr>
                <td><label>{t("batchList7") || "Fecha"}</label></td>
                <td>
                  <DatePicker
                    selected={dateBegin}
                    onChange={setDateBegin}
                    dateFormat="yyyy-MM-dd"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>
              <tr>
                <td><label>{t("batchList8") || "Hora Inicio"}</label></td>
                <td>
                  <DatePicker
                    selected={timeBegin}
                    onChange={setTimeBegin}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>
              <tr>
                <td><label>{t("batchList10") || "Hora Fin"}</label></td>
                <td>
                  <DatePicker
                    selected={timeEnd}
                    onChange={setTimeEnd}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>


              */}


              {/* Si quieres mostrar derivados (solo lectura) */}
              
              {/*}
              <tr><td colSpan={2}><hr/></td></tr>
              <tr><td>Total horas</td><td><input className="input1" value={totalHr ?? "-"} disabled/></td></tr>
              <tr><td>Operaciones</td><td><input className="input1" value={totalOper ?? "-"} disabled/></td></tr>
              <tr><td>Oper std x hr</td><td><input className="input1" value={operStdXhr ?? "-"} disabled/></td></tr>
              <tr><td>Und x oper</td><td><input className="input1" value={undXOper ?? "-"} disabled/></td></tr>
              <tr><td>Und std x hr</td><td><input className="input1" value={undStdXhr ?? "-"} disabled/></td></tr>
              <tr><td>% Efic. Ops</td><td><input className="input1" value={percentEff ?? "-"} disabled/></td></tr>
              <tr><td>% Efic. Prod</td><td><input className="input1" value={productEff ?? "-"} disabled/></td></tr>
              <tr><td>% Conformidad</td><td><input className="input1" value={conforming ?? "-"} disabled/></td></tr>
            </tbody>
          </table>

          <button type="submit" className="button7" disabled={saving}>
            {saving ? t("Guardando...") : t("Guardar")}
          </button>
          <button type="button" className="button7" onClick={()=>navigate(-1)}>
            {t("Cancelar")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditBatchForm;
*/}
